var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.333 4.174a6.16 6.16 0 1 0 0 12.319 6.16 6.16 0 0 0 0-12.32M2 10.334a8.333 8.333 0 1 1 16.666 0 8.333 8.333 0 0 1-16.666 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.12 15.12a1.07 1.07 0 0 1 1.515 0l5.05 5.05a1.071 1.071 0 1 1-1.515 1.516l-5.05-5.051a1.07 1.07 0 0 1 0-1.515"
}))));
export default SvgSearch;